import React from 'react'
import background from '../../Assets/Hero/home_who_are_we.jpeg'
import line from '../../Assets/icons/line.svg'

function WhoAreWe() {
    return (
        <div className="w-full bg-white">
            <div className="mx-auto max-w-[1640px] lato z-10 relative pt-[3rem] pb-[5rem]" 
            style={{ 
                backgroundImage: `url(${background})`, 
                backgroundSize: 'cover', 
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                minHeight: 'auto',
            }}
            >
                <div className='text-center p-4 md:p-8'>
                    <div className='inline-flex items-center justify-center'>
                        <img src={line} alt="" className="h-1 w-full max-w-[100px] md:max-w-[150px]" />
                        <p style={{ fontSize: 'clamp(17px,1.2vw,20px)'}} className='uppercase text-[#463820] opacity-[63%] font-semibold mx-2 w-[18rem]'>who are we</p>
                        <img src={line} alt="" className="h-1 w-full max-w-[100px] md:max-w-[150px]" />
                    </div>
                    <div className='mt-4'>
                        <p style={{ fontSize: 'clamp(24px,4vw,46px)'}} className='uppercase text-[#99702B] w-[90%] md:w-[80%] mx-auto font-extrabold'>OUR PASSION FOR IT AND E-COMMERCE EXCELLENCE RUNS DEEP</p>
                    </div>
                    <div className='mt-4'>
                        <p style={{ fontSize: 'clamp(16px,2.5vw,28px)'}} className='text-[#726652] w-[90%] md:w-[80%] mx-auto font-semibold leading-[1.5] md:leading-[1.75]'>
                            At Dynamic Leo, your IT and e-commerce projects are our priority. We transform your ideas into digital solutions that fuel success. Our expertise in software development and e-commerce platforms ensures that your business stays ahead in the ever-evolving digital landscape. Just as technology continuously advances, our commitment to innovation and excellence never wavers.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhoAreWe
